import React, { lazy, useMemo } from "react";

import { useFeatureFlag } from "fond/featureFlags";
import { RoutedTabs, TabDefinition } from "fond/widgets/RoutedTabs";

import { SettingsTabContent } from "../common.styles";

const EditProfileFormTab = lazy(() => import("./EditProfileForm/EditProfileForm"));
const ChangePasswordTab = lazy(() => import("./ChangePasswordForm/ChangePasswordForm"));
const MFASettingsTab = lazy(() => import("./MFASettings/MFASettings"));
const PendingInvitesTab = lazy(() => import("./PendingInvites/PendingInvites"));

const UserProfile: React.FC = () => {
  const { value: isMfaEnabled } = useFeatureFlag("security_mfa", false);

  const tabs: TabDefinition[] = useMemo(() => {
    const baseTabs: TabDefinition[] = [
      { label: "Details", path: "details", component: EditProfileFormTab, event: "settings.profile.details.viewed" },
      { label: "Change Password", path: "change-password", component: ChangePasswordTab, event: "settings.profile.change-password.viewed" },
    ];

    if (isMfaEnabled) {
      baseTabs.push({ label: "Multi-Factor Auth", path: "mfa", component: MFASettingsTab });
    }

    baseTabs.push({
      label: "Pending Invites",
      path: "account-invites",
      component: PendingInvitesTab,
      event: "settings.profile.account-invites.viewed",
    });

    return baseTabs;
  }, [isMfaEnabled]);

  return <RoutedTabs ContentContainer={SettingsTabContent} prefix="/settings/profile" tabs={tabs} data-testid="user-profile" />;
};

export default UserProfile;
